export const ALERTS_REQUEST: string = "ALERTS_REQUEST";
export const MAP_OBJECTS_REQUEST: string = "MAP_OBJECTS_REQUEST";
export const OBJECT_DATA_REQUEST: string = "OBJECT_DATA_REQUEST";
export const OBJECTS_REQUEST: string = "OBJECTS_REQUEST";
export const OBJECT_TRACK_REQUEST: string = "OBJECT_TRACK_REQUEST";
export const OBJECTS_SUMMARY_REQUEST: string = "OBJECTS_SUMMARY_REQUEST";
